import {actions} from "./actions";

export function getToggles(dispatch, globalDispatch) {
  return {
    toggleShowClosedOrInactive: payload => dispatch(
      {type: actions.TOGGLE_SHOW_CLOSED_OR_INACTIVE, payload: payload}),
    toggleIsSavingActivities: payload => dispatch(
      {type: actions.TOGGLE_IS_SAVING_ACTIVITIES, payload: payload}),
  }
}